export default "__VITE_ASSET__DlFGtYpp__"